import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConnectionService, EnvironmentBase, LanguageService, PwaService } from '@definitiv-packages/angular-dba-library';
import { AppService, ObjektViewService, ProjectLanguage, SafetyPointFormModelViewService, SafetyPointViewService, TodoViewService } from '../../../roofsafetymanagement-library/src/public-api';

import { ScanService } from './services/scan.service';
import { skip } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  public loading: boolean = true;
  public language: ProjectLanguage | null = null;
  public todosCount: number = 0;
  constructor(
    @Inject(EnvironmentBase) public environment: EnvironmentBase,
    public connection: ConnectionService,
    public appService: AppService,
    private languageService: LanguageService,
    private objektViewService: ObjektViewService,
    private todoservice: TodoViewService,
    private safetyPointFormModelViewService: SafetyPointFormModelViewService,
    private router: Router,
    private safetyPointService: SafetyPointViewService,
    scanService: ScanService,
    pwaService: PwaService
  ) {
      pwaService.Init();
      //scanService.safetyPoint.pipe(skip(1)).subscribe(id =>{ this.handleScan(id)} );
  }

  public async ngOnInit() {
    
    try {
      
      await this.appService.init();
      this.language = this.languageService.getLanguageAsSetter<ProjectLanguage>();
      await this.appService.loginFromLocalStorage();
      
      await this.todoservice.getCountTodos();

        this.todoservice.todoCount$.subscribe(x => {
          this.todosCount = x;
        });              
              
    } finally {
        this.loading = false;
    }
  }

  logout(){
    
  }
  public refresh(): void {
    window.location.reload();
  }
  private async handleScan(electronicId: string): Promise<void> {        
    var safetyPointList = await this.safetyPointService.getFilteredList({ ElectronicId: electronicId });  
    if (safetyPointList.length > 0) {
      this.router.navigate(['/object-service', safetyPointList[0].ObjektID], { queryParams: { electronicId: electronicId } });
    }
  }
 
}
